<template>
  <div>
    <Header :title="title" />
    <v-card elevation="2" class="mx-auto header-row">
      <v-row class="ma-0 pa-0">
        <v-col :cols="12" :lg="8" :md="8" :sm="12" class="d-flex align-center">
          <p class="py-0 pl-3 my-0 header-text text-white text-uppercase">
            {{ title }}
          </p>
        </v-col>
        <v-col :cols="12" :lg="4" :md="4" :sm="12">
          <LangSelector />
          <div class="float-right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="white" dark outlined class="ma-1" v-bind="attrs" v-on="on" @click="excelExport">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>excel export</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card outlined elevation="1" class="mx-auto mt-5 mb-5 main-card" v-if="subjects && subjects.length > 0 && !$store.state.overlay">
      <div class="modulbg px-3 rounded">
        <p>
          <b>{{ $store.state.lang.szak }}:</b>
          {{ langName == "hu" ? samplePlan.faculty : samplePlan_en.faculty }}
        </p>
        <p>
          <b>{{ $store.state.lang.szakirany }}:</b>
          {{
            langName == "hu"
              ? samplePlan.specialization
              : samplePlan_en.specialization
          }}
        </p>
        <p>
          <b>{{ $store.state.lang.mintaterv }}:</b>
          {{
            langName == "hu" ? samplePlan.samplePlan : samplePlan_en.samplePlan
          }}
        </p>
      </div>
      <p class="text-justify">
        {{ $store.state.lang.archive_targyak }}
      </p>
      <v-row v-if="title != 'Általános' && !$store.state.overlay">
        <v-col :cols="12" :lg="12" :md="12" :sm="12" v-for="(type, key) in subjects" :key="key">
          <v-divider class="mx-4"></v-divider>
          <p v-if="key == 0">
            <b v-if="langName == 'hu'">{{ type.name }}</b>
            <b v-if="langName == 'en'">Mandatory subjects</b>
          </p>
          <p v-else>
            <b>{{ type.name }}</b>
          </p>
          <p>
            {{ type.leiras }}
          </p>
          <v-simple-table v-if="type.children.length == 0 && type.subjects.length > 0">
            <template>
              <thead>
                <tr class="uni_blue2">
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_sorszam }}
                  </th>
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_kod }}
                  </th>
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_megnevezes }}
                  </th>
                  <th class="p-2 text-light border" v-if="samplePlan.type != 'Levelező'">
                    {{ $store.state.lang.table_heti_elmelet }}
                  </th>
                  <th class="p-2 text-light border" v-else>
                    {{ $store.state.lang.table_feleves_elmelet }}
                  </th>
                  <th class="p-2 text-light border" v-if="samplePlan.type != 'Levelező'">
                    {{ $store.state.lang.table_heti_gyakorlat }}
                  </th>
                  <th class="p-2 text-light border" v-else>
                    {{ $store.state.lang.table_feleves_gyakorlat }}
                  </th>
                  <th class="p-2 text-light border" v-if="samplePlan.type != 'Levelező'">
                    {{ $store.state.lang.table_heti_labor }}
                  </th>
                  <th class="p-2 text-light border" v-else>
                    {{ $store.state.lang.table_feleves_labor }}
                  </th>
                  <th class="p-2 text-light border" v-if="isDayType(samplePlan)">
                    {{ $store.state.lang.table_project_orak }}
                  </th>
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_beszamolas_fajtaja }}
                  </th>
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_kreditpont }}
                  </th>
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_ajanlott_felev }}
                  </th>
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_elotanulmanyi_kov }}
                  </th>
                  <th class="p-2 text-light border">
                    {{ $store.state.lang.table_adminisztrativ }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(subject, index) in type.subjects" :key="index" :style="`${subject.archive == 'igaz'
                  ? 'color: grey; font-style: italic;'
                  : ''
                  }`">
                  <td class="px-2 border">{{ index + 1 }}</td>
                  <td class="px-2 border">
                    <a href="javascript:void(0)" @click="tantargytematika(subject.Targykod)" style="color: #0c3c60">{{
                      subject.Targykod }}</a>
                  </td>
                  <td class="px-2 border" v-if="subject.archive == 'hamis'">
                    {{ subject.Targynev }}
                  </td>
                  <td class="px-2 border" v-if="subject.archive == 'igaz'">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <p v-bind="attrs" v-on="on">
                          {{ subject.Targynev }}
                        </p>
                      </template>
                      <span>Archivalt tantárgy</span>
                    </v-tooltip>
                  </td>
                  <td class="px-2 border" v-if="subject.F5 != null">
                    {{ subject.F5 }}
                  </td>
                  <td class="px-2 border" v-if="subject.F22 != null">
                    {{ subject.F22 }}
                  </td>
                  <td class="px-2 border" v-if="subject.F22 == null && subject.F5 == null">
                    0
                  </td>
                  <td class="px-2 border" v-if="subject.F7 != null">
                    {{ subject.F7 }}
                  </td>
                  <td class="px-2 border" v-if="subject.F23 != null">
                    {{ subject.F23 }}
                  </td>
                  <td class="px-2 border" v-if="subject.F7 == null && subject.F23 == null">
                    0
                  </td>
                  <td class="px-2 border" v-if="subject.F18 != null">
                    {{ subject.F18 }}
                  </td>
                  <td class="px-2 border" v-if="subject.F24 != null">
                    {{ subject.F24 }}
                  </td>
                  <td class="px-2 border" v-if="subject.F18 == null && subject.F24 == null">
                    0
                  </td>
                  <td class="p-2 border" v-if="isDayType(samplePlan)">
                    {{ isProjectType(subject) }}
                  </td>
                  <td class="px-2 border" v-if="langName != 'hu'">
                    {{ subject.beszamolo_en }}
                  </td>
                  <td class="px-2 border" v-else>{{ subject.F27 }}</td>
                  <td class="px-2 border">
                    <p v-if="subject.Targy_kredit != null">
                      {{ subject.Targy_kredit }}
                    </p>
                    <p v-if="subject.Targy_kredit == null">0</p>
                  </td>
                  <td class="px-2 border">{{ subject.Felev_szam }}</td>
                  <td class="px-2 border">
                    <p v-if="subject.Elokovetelmeny_leiras_1 != null">
                      {{ subject.Elokovetelmeny_leiras_1 }}
                    </p>

                    <p v-if="subject.Elokovetelmeny_leiras_2 != null">
                      {{ subject.Elokovetelmeny_leiras_2 }}
                    </p>
                  </td>
                  <td v-if="subject.admin.Targykod != ''" class="px-2 border">
                    <p>
                      {{ $store.state.lang.table_admin_1 }}
                      {{ subject.admin.Targykod }}
                      {{ $store.state.lang.table_admin_2 }}
                    </p>
                  </td>
                  <td v-else class="px-2 border"></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div v-else class="ml-8">
            <div v-for="(child, childKey) in type.children" :key="childKey">
              <p>
                <b>{{ child.name }}</b>
              </p>
              <p>
                {{ child.leiras }}
              </p>
              <v-simple-table class="border" v-if="type.children.length != 0">
                <template>
                  <thead>
                    <tr class="uni_blue2">
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_sorszam }}
                      </th>
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_kod }}
                      </th>
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_megnevezes }}
                      </th>
                      <th class="p-2 text-light border" v-if="samplePlan.type != 'Levelező'">
                        {{ $store.state.lang.table_heti_elmelet }}
                      </th>
                      <th class="p-2 text-light border" v-else>
                        {{ $store.state.lang.table_feleves_elmelet }}
                      </th>
                      <th class="p-2 text-light border" v-if="samplePlan.type != 'Levelező'">
                        {{ $store.state.lang.table_heti_gyakorlat }}
                      </th>
                      <th class="p-2 text-light border" v-else>
                        {{ $store.state.lang.table_feleves_gyakorlat }}
                      </th>
                      <th class="p-2 text-light border" v-if="samplePlan.type != 'Levelező'">
                        {{ $store.state.lang.table_heti_labor }}
                      </th>
                      <th class="p-2 text-light border" v-else>
                        {{ $store.state.lang.table_feleves_labor }}
                      </th>
                      <th class="p-2 text-light border" v-if="isDayType(samplePlan)">
                        {{ $store.state.lang.table_project_orak }}
                      </th>
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_beszamolas_fajtaja }}
                      </th>
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_kreditpont }}
                      </th>
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_ajanlott_felev }}
                      </th>
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_elotanulmanyi_kov }}
                      </th>
                      <th class="p-2 text-light border">
                        {{ $store.state.lang.table_adminisztrativ }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- {{ child.subjects }} -->
                    <tr v-for="(subjectChild, indexChild) in child.subjects" :key="indexChild" :style="`${subject.archive == 'igaz'
                      ? 'color: grey; font-style: italic;'
                      : ''
                      }`">
                      <!-- sorszám -->
                      <td class="px-2 border">{{ indexChild + 1 }}</td>
                      <!-- tárgykód -->
                      <td class="px-2 border">
                        <a href="javascript:void(0)" @click="tantargytematika(subjectChild.Targykod)"
                          style="color: #0c3c60">{{ subjectChild.Targykod }}</a>
                      </td>
                      <!-- tárgynév -->
                      <td class="px-2 border" v-if="subjectChild.archive == 'hamis'">
                        {{ subjectChild.Targynev }}
                      </td>
                      <td class="px-2 border" v-if="subjectChild.archive == 'igaz'">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <p v-bind="attrs" v-on="on">
                              {{ subjectChild.Targynev }}
                            </p>
                          </template>
                          <span>Archivalt tantárgy</span>
                        </v-tooltip>
                      </td>
                      <!-- Heti elmélet -->
                      <td class="px-2 border" v-if="subjectChild.F5 != null">
                        {{ subjectChild.F5 }}
                      </td>
                      <!-- Féléves elmélet -->
                      <td class="px-2 border" v-if="subjectChild.F22 != null">
                        {{ subjectChild.F22 }}
                      </td>
                      <!-- Ha mindkető null, akkor 0 -->
                      <td class="px-2 border" v-if="
                        subjectChild.F22 == null && subjectChild.F5 == null
                      ">
                        0
                      </td>
                      <!-- Heti gyakorlat -->
                      <td class="px-2 border" v-if="subjectChild.F7 != null">
                        {{ subjectChild.F7 }}
                      </td>
                      <!-- Féléves gyakorlat -->
                      <td class="px-2 border" v-if="subjectChild.F23 != null">
                        {{ subjectChild.F23 }}
                      </td>
                      <!-- Ha mindkető null, akkor 0 -->
                      <td class="px-2 border" v-if="
                        subjectChild.F7 == null && subjectChild.F23 == null
                      ">
                        0
                      </td>
                      <!-- Heti labor -->
                      <td class="px-2 border" v-if="subjectChild.F18 != null">
                        {{ subjectChild.F18 }}
                      </td>
                      <!-- Féléves labor -->
                      <td class="px-2 border" v-if="subjectChild.F24 != null">
                        {{ subjectChild.F24 }}
                      </td>
                      <!-- Ha mindkető null, akkor 0 -->
                      <td class="px-2 border" v-if="
                        subjectChild.F18 == null && subjectChild.F24 == null
                      ">
                        0
                      </td>
                      <!-- Ha nappali, akkor mutassa, hogy projekt-->
                      <td class="p-2 border" v-if="isDayType(samplePlan)">
                        {{ isProjectType(subjectChild) }}
                      </td>
                      <!-- Beszámoló fajtája -->
                      <td class="px-2 border" v-if="langName != 'hu'">
                        {{ subjectChild.beszamolo_en }}
                      </td>
                      <td class="px-2 border" v-else>{{ subjectChild.F27 }}</td>
                      <td class="px-2 border">
                        <p v-if="subjectChild.Targy_kredit != null">
                          {{ subjectChild.Targy_kredit }}
                        </p>
                        <p v-if="subjectChild.Targy_kredit == null">0</p>
                      </td>
                      <td class="px-2 border">{{ subjectChild.Felev_szam }}</td>
                      <td class="px-2 border">
                        <p v-if="subjectChild.Elokovetelmeny_leiras_1 != null">
                          {{ subjectChild.Elokovetelmeny_leiras_1 }}
                        </p>

                        <p v-if="subjectChild.Elokovetelmeny_leiras_2 != null">
                          {{ subjectChild.Elokovetelmeny_leiras_2 }}
                        </p>
                      </td>
                      <td v-if="subjectChild.admin.Targykod != ''" class="px-2 border">
                        <p>
                          {{ $store.state.lang.table_admin_1 }}
                          {{ subjectChild.admin.Targykod }}
                          {{ $store.state.lang.table_admin_2 }}
                        </p>
                      </td>
                      <td v-else class="px-2 border"></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div v-if="child.credit != null && child.credit != ''">
                <p v-if="
                  !(
                    (child.name ? child.name : '').includes('Idegen') ||
                    (child.name ? child.name : '').includes('Testnevelés') ||
                    (child.name ? child.name : '').includes(
                      'Kötelező tárgyak'
                    ) ||
                    (child.name ? child.name : '').includes(
                      '(kötelező törzsanyag)'
                    ) ||
                    (child.name ? child.name : '').includes(
                      '(Kötelező törzsanyag)'
                    )
                  )
                ">
                  <b>{{ $store.state.lang.elvegzett_credit }}
                    {{ child.credit }}</b>
                </p>
                <p v-if="
                  (child.name ? child.name : '').includes(
                    'Kötelező tárgyak'
                  ) ||
                  (child.name ? child.name : '').includes(
                    '(kötelező törzsanyag)'
                  ) ||
                  (child.name ? child.name : '').includes(
                    '(Kötelező törzsanyag)'
                  )
                ">
                  <b>{{ $store.state.lang.elvegzett_credit_kotelezo }}
                    {{ child.credit }}</b>
                </p>
              </div>
              <p v-if="(child.name ? child.name : '').includes('Testnevelés')">
                <b>{{ $store.state.lang.elvegzett_credit_testneveles }}
                  {{ child.tantargyak_szama }}</b>
              </p>
              <p v-if="
                child.credit == null &&
                child.tantargyak_szama != null &&
                !(child.name ? child.name : '').includes('Testnevelés')
              ">
                <b>{{ $store.state.lang.elvegzett_tantargy_csoport }}
                  {{ child.tantargyak_szama }}</b>
              </p>
            </div>
          </div>
          <div v-if="type.credit != null && type.credit != ''">
            <p v-if="
              !(
                (type.name ? type.name : '').includes('Idegen') ||
                (type.name ? type.name : '').includes('Testnevelés') ||
                (type.name ? type.name : '').includes('Kötelező tárgyak') ||
                (type.name ? type.name : '').includes(
                  '(kötelező törzsanyag)'
                ) ||
                (type.name ? type.name : '').includes('(Kötelező törzsanyag)')
              )
            ">
              <b>{{ $store.state.lang.elvegzett_credit }} {{ type.credit }}</b>
            </p>
            <p v-if="
              (type.name ? type.name : '').includes('Kötelező tárgyak') ||
              (type.name ? type.name : '').includes(
                '(kötelező törzsanyag)'
              ) ||
              (type.name ? type.name : '').includes('(Kötelező törzsanyag)')
            ">
              <b>{{ $store.state.lang.elvegzett_credit_kotelezo }}
                {{ type.credit }}</b>
            </p>
          </div>
          <p v-if="(type.name ? type.name : '').includes('Testnevelés')">
            <b>{{ $store.state.lang.elvegzett_credit_testneveles }}
              {{ type.tantargyak_szama }}</b>
          </p>
          <p v-if="
            type.credit == null &&
            type.tantargyak_szama != null &&
            !(type.name ? type.name : '').includes('Testnevelés')
          ">
            <b>{{ $store.state.lang.elvegzett_tantargy_csoport }}
              {{ type.tantargyak_szama }}</b>
          </p>
        </v-col>
      </v-row>
    </v-card>
    <div class="text-center">
      <v-dialog v-model="dialog" width="1000px">
        <v-card class="pa-0 ma-0">
          <v-card-title class="p-3 d-flex justify-end sticky">
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="ma-0 pa-0">
            <TantargyTematika :subject="subject" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <NotFoundCard v-if="subjects.length < 1 && !$store.state.overlay" class="mt-5" />
  </div>
</template>

<script>
import LangSelector from "@/components/LangSelector.vue";
import TantargyTematika from "@/components/TantargyTematika.vue";
import Header from "@/components/Header.vue";
import NotFoundCard from "../components/notFoundCard.vue";

export default {
  props: ["mintaterv"],
  components: {
    Header,
    TantargyTematika,
    LangSelector,
    NotFoundCard
  },
  data: () => ({
    title: "",
    type: "",
    selected: "",
    dialog: false,
    subjects: [],
    subject: {},
    samplePlan: {},
    URLSamplePlan: {
      id: "",
    },
    samplePlan_en: {},
  }),

  async mounted() {
    this.$store.commit("setOverlay", true);
    this.URLSamplePlan.id = this.$route.params.id;
    try {
      const response = await this.$http.get(
        "getSubjects/",
        {
          params: {
            id: this.$route.params.id,
          },
        },
        { timeout: 6000 }
      );
      this.samplePlan = {
        department: "",
        faculty: response.information[0].F3,
        specialization: response.information[0].F7,
        samplePlan: response.information[0].F10,
        type: response.information[0].F4,
        level: response.information[0].F5,
      };
      this.samplePlan_en = {
        faculty: response.information[0].F16,
        specialization: response.information[0].F17,
        samplePlan: response.information[0].F18,
      };
      this.title = this.samplePlan.samplePlan;
      this.subjects = response.types;
    } catch (e) {
      console.error(e);
    } finally {
      this.$store.commit("setOverlay", false);
    }
  },

  computed: {
    langName() {
      this.$store.commit("setLanguage", this.$route.params.lang);
      return this.$route.params.lang;
    },
  },

  methods: {
    isDayType(item) {
      return item.type.toLowerCase() == "nappali";
    },
    isProjectType(subject) {
      return subject.kurzustipus &&
        subject.kurzustipus.toLowerCase() == "projekt"
        ? subject.heti_oraszam
        : "0";
    },
    async tantargytematika(subjectCode) {
      try {
        this.subject = null;
        const response = await this.$http.get(
          "getSubjectDetails/" + subjectCode
        );
        this.subject = response.details;
      } catch (e) {
        console.error(e);
      } finally {
        this.dialog = true;
      }
    },

    async excelExport() {
      try {
        this.$store.commit("setOverlay", true);

        const response = await this.$http.get("excelExport/", {
          params: {
            id: this.URLSamplePlan.id,
            lang: this.$route.params.lang,
          },
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${this.URLSamplePlan.id}_export.xlsx`);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.commit("setOverlay", false);
      }
    },

  },
};
</script>

<style scoped>
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td {
  height: 25px;
}

.v-data-table td {
  text-align: center;
}

p {
  margin: 0.5rem 0;
}

.header-row {
  background-color: #0c3c60;
}

a {
  display: inline-block;
  position: relative;
  text-decoration: none;
  overflow: hidden;
}

a::after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 0.05em;
  transform: scaleX(0);
  background-color: #0c3c60;
  transform-origin: bottom right;
}

a:hover:after {
  transform: scaleX(1);
  transform-origin: bottom left;
  transition: transform 0.25s ease-in;
}

.modulbg {
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-radius: 1px;
  background-color: #0c3c60;
  color: white;
}
</style>